import { Component, inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { take } from 'rxjs';
import { OperationsModule } from '../operations/operations.module';
import { FileUploadComponent } from '../operations/shared/file-upload/file-upload.component';

/**
 * FileUploadPageComponent
 *
 * Acts as a routing-only page that immediately opens the file upload dialog
 * when the component is initialized. The dialog is non-dismissible to ensure
 * the upload flow is completed or explicitly closed by the user.
 *
 * After the dialog is closed, the user is automatically redirected to the
 * home route.
 *
 * This component does not render its own UI and exists solely to coordinate
 * dialog presentation and navigation.
 */
@Component({
  selector: 'app-file-upload-page',
  imports: [OperationsModule],
  templateUrl: './file-upload-page.component.html',
  styleUrl: './file-upload-page.component.scss',
})
export class FileUploadPageComponent implements OnInit {
  private readonly dialog = inject(MatDialog);
  private readonly route = inject(Router);

  /**
   * Opens the file upload dialog on initialization and redirects to the home
   * route once the dialog is closed.
   */
  ngOnInit(): void {
    this.dialog
      .open(FileUploadComponent, {
        disableClose: true,
      })
      .afterClosed()
      .pipe(take(1))
      .subscribe(() => {
        this.route.navigate(['home']);
      });
  }
}
